import { reactive, computed } from 'vue';
import { GroupMemberDto } from './groupMemberDto';
import { GroupDetailsDto } from './groupDetailsDto';
import resourceHelper from '@/Utils/resourceHelper';

export class GroupSummaryDto {
  groupId: string;
  groupDetails: GroupDetailsDto;
  groupMembers: GroupMemberDto[];
  membersSummary: string;
  validationRules!: object;

  constructor(groupId: string, groupDetails: GroupDetailsDto, groupMembers: GroupMemberDto[]) {
    this.groupId = groupId;
    this.groupDetails = groupDetails;
    this.groupMembers = reactive(groupMembers);

    this.membersSummary = computed(() => this.getMembersSummary()).value;

  }

  /**
   * Gets the count of members and primary contact as a human readable string
   * @return {string}
   */
  getMembersSummary(): string {
    const memberCount = this.groupMembers.length;
    const allPrimaryContacts = this.groupMembers.filter(m => m.isGroupPrimaryContact).length;
    let label = '';

    if (memberCount === 1) {
      label += `1 ${resourceHelper.getString('User').toLowerCase()}`;
    } else {
      label += `${memberCount} ${resourceHelper.getString('Users').toLowerCase()}`;
    }

    if (allPrimaryContacts === 1) {
      label += ` ${resourceHelper.getString('PrimaryGroupContactsSingleSummary')}`;
    } else if (allPrimaryContacts !== 0) {
      const replaceObj = { count: allPrimaryContacts };
      label += ` ${resourceHelper.getString('PrimaryGroupContactsMultipleSummary', replaceObj)}`;
    }

    return label;
  }
}
